import React from 'react';

import { Body } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { ModuleHeader, ModuleHeaderSize } from '@/components/ModuleHeader';
import { ModuleProductsSkeleton } from '@/components/ModuleProductsSkeleton';

export function RecentSearchesPlaceholder() {
  const tHome = useTranslations('home');
  const tCommon = useTranslations('common');

  return (
    <section>
      <ModuleHeader
        title={tHome('NewForYourSearch')}
        size={ModuleHeaderSize.Large}
      >
        <Body variant="sm-regular" className={styles.seeMoreText}>
          {tCommon('SeeMore')}
        </Body>
      </ModuleHeader>

      <ModuleProductsSkeleton itemsPerRow={6} productsCount={6} />
    </section>
  );
}
